function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _omit from 'lodash/omit';
import Checkbox from '../Checkbox';
import Label from '../Label';
import { getValidElementProps } from '../utils/htmlValidProps';

require('xps-style/core/checkboxgroup.css');

var CheckboxGroup = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxGroup, _Component);

  var _super = _createSuper(CheckboxGroup);

  function CheckboxGroup() {
    _classCallCheck(this, CheckboxGroup);

    return _super.apply(this, arguments);
  }

  _createClass(CheckboxGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          className = _this$props.className,
          label = _this$props.label,
          values = _this$props.values,
          error = _this$props.error,
          children = _this$props.children,
          required = _this$props.required,
          selected = _this$props.selected,
          disabled = _this$props.disabled,
          description = _this$props.description,
          checkboxChange = _this$props.checkboxChange;
      var inputId = id || name;
      var labelText = label || name;
      var componentProps = getValidElementProps('div', this.props);

      var subcomponentProps = _omit(getValidElementProps('input', this.props), ['name', 'id']);

      var checkboxIdString = id || "".concat(name.replace(/ /g, '_'));
      var labelId = "".concat(checkboxIdString, "__label");
      var ntClass = cx({
        checkboxgroup: true,
        'checkboxgroup--error': !!error
      }, className);
      var generatedCheckboxes = values.map(function (value, index) {
        var checkboxId = "".concat(checkboxIdString, "_").concat(index);
        return /*#__PURE__*/React.createElement(Checkbox, _extends({
          value: value,
          name: name,
          id: checkboxId,
          error: error,
          disabled: disabled
        }, selected.includes(value) && {
          defaultChecked: true
        }, {
          key: checkboxId,
          onChange: checkboxChange
        }, subcomponentProps));
      });

      var checkboxGroupAdaProps = _objectSpread(_objectSpread({
        'aria-labelledby': labelId,
        'aria-invalid': !!error
      }, description && !error && {
        'aria-describedby': "".concat(checkboxIdString, "__description")
      }), error && {
        'aria-describedby': "".concat(checkboxIdString, "__error")
      });

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "checkboxgroup-required__container"
      }, /*#__PURE__*/React.createElement(Label, {
        name: inputId,
        text: labelText,
        className: "checkboxgroup__label",
        id: labelId
      }), required && /*#__PURE__*/React.createElement("span", {
        className: "checkboxgroup__label-required font-sm"
      }, "Required")), error && /*#__PURE__*/React.createElement("div", {
        role: "alert",
        id: "".concat(checkboxIdString, "__error"),
        className: "checkboxgroup-error__info color-text--error"
      }, error), /*#__PURE__*/React.createElement("div", _extends({}, checkboxGroupAdaProps, {
        className: ntClass,
        role: "group"
      }, componentProps), generatedCheckboxes, children), description && /*#__PURE__*/React.createElement("div", {
        id: "".concat(checkboxIdString, "__description"),
        className: "input__info font-sm"
      }, description));
    }
  }]);

  return CheckboxGroup;
}(Component);

_defineProperty(CheckboxGroup, "refreshProps", {});

_defineProperty(CheckboxGroup, "propTypes", {
  /** The id to be set on the container */
  id: PropTypes.string,

  /** The name of the field */
  name: PropTypes.string.isRequired,

  /** Any additional Classes to be added to the container */
  className: PropTypes.string,

  /** The label of the entire containing field (Note: This is not for the individual input labels) */
  label: PropTypes.string,

  /** The values to be used as inputs */
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),

  /** The selected value */
  selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),

  /** Child elements */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  error: PropTypes.string,
  required: PropTypes.bool,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  checkboxChange: PropTypes.func
});

_defineProperty(CheckboxGroup, "defaultProps", {
  error: null,
  values: [],
  selected: [],
  required: false
});

CheckboxGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CheckboxGroup",
  "props": {
    "error": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "values": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "number"
          }]
        }
      },
      "required": false,
      "description": "The values to be used as inputs"
    },
    "selected": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "number"
          }]
        }
      },
      "required": false,
      "description": "The selected value"
    },
    "required": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The id to be set on the container"
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "The name of the field"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Any additional Classes to be added to the container"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The label of the entire containing field (Note: This is not for the individual input labels)"
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }, {
          "name": "node"
        }]
      },
      "required": false,
      "description": "Child elements"
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "checked": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "checkboxChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default CheckboxGroup;